<template>
	<div class="row">
		<div class="col-6">
			<input class="form-control text-right" v-model="from" type="text">
		</div>
		<div class="col-6">
			<input class="form-control text-right" v-model="to" type="text">
		</div>
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";

    export default {
        name: 'vfg-amountRange',
        mixins: [ abstractField ],
	    watch: {
            'to' () {
                this.value = {
                    a: this.from,
	                b: this.to
                }
                this.reset()
            },
            'from' () {
                this.value = {
                    a: this.from,
                    b: this.to
                }
                this.reset()
            }
	    },
        data () {
            return {
				from: 0,
	            to: 0,
            }
        },
        methods: {
			reset () {
			    if (!this.from && !this.to) {
			        this.value = '';
			    }
			}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/form/fieldAmountRange.vue